/*import React, { useEffect, useState } from 'react';
import {
  NativeSelect,
  TextField,
  Box,
  FormControl,
  Stack,
  Divider,
  Typography,
  Button,
  Autocomplete,
} from '@mui/material';

import { toast } from 'react-toastify';
import moment from 'moment';

import api from '../../../../api/api';
import { useAuthState } from '../../../../contexts/AuthContext';
import Spinner from '../../../../components/Spinner/Spinner';
import TabelaResultados from './TabelaResultados/TabelaResultados';
import TitlePage from '../../../../components/TitlePage/TitlePage';
import { useConfirm } from 'material-ui-confirm';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchComponent from '../../../../components/SearchComponent/SearchComponent';
const ReservaMateriaPrima = () => {
  const { empresaAtiva, usuarioIDLogado } = useAuthState();
  const [loading, setLoading] = useState(false);
  const [listaOrdens, setListaOrdens] = useState([]);
  const [listaClientes, setListaClientes] = useState([]);
  const [listaMateriasPrima, setListaMateriasPrimas] = useState([]);
  const [dataInicio, setDataInicio] = useState(moment().format('YYYY-MM-DD'));
  const [dataFim, setDataFim] = useState(moment().format('YYYY-MM-DD'));
  const [tipoFiltro, setTipoFiltro] = useState('');
  const [clienteSelecionado, setClienteSelecionado] = useState();
  const [atualizaFiltro, setAtualizaFiltro] = useState(false);
  const confirm = useConfirm();
  const [parametroFiltro, setParametroFiltro] = useState({
    emissaoInicio: '',
    emissaoFim: '',
    entregaInicio: '',
    entregaFim: '',
    cliente: '',
    status: 'RESERVA',
    materia: '0',
    maquina: '',
  });

  useEffect(() => {
    setLoading(true);
    api
      .post('/producao/lista', parametroFiltro, {
        headers: { banco: empresaAtiva },
      })
      .then(({ data }) => {
        setListaOrdens(data);
        console.log(data);
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  }, [parametroFiltro, empresaAtiva, atualizaFiltro]);

  useEffect(() => {
    api
      .get('/cliente/lista1', {
        headers: {
          banco: empresaAtiva,
        },
      })
      .then(({ data }) => {
        setListaClientes(data);
      })
      .catch(({ data }) =>
        toast.error('Erro ao buscar dados do cliente', data)
      );
  }, [parametroFiltro, empresaAtiva, atualizaFiltro]);

  useEffect(() => {
    api
      .post(
        '/materiaPrima/lista',
        { estoque: 'SIM' },
        {
          headers: {
            banco: empresaAtiva,
          },
        }
      )
      .then(({ data }) => {
        setListaMateriasPrimas(data);
      })
      .catch((err) => {
        console.log(err);
        toast.error('Erro ao buscar dados da MateriaPrima', err);
      });
  }, [parametroFiltro, empresaAtiva, atualizaFiltro]);

  /*const selecionaFiltro = (tipoFiltro) => {
    console.log('tipofiltro ', tipoFiltro);

    /*setClienteSelecionado((prevState) => {
      if (tipoFiltro == 'cliente') {
        return tipoFiltro.cliente;
      }
      return prevState;
    });
    setTipoFiltro(tipoFiltro.tipoFiltro);
    setClienteSelecionado(tipoFiltro.cliente);
    switch (tipoFiltro.tipoFiltro) {
      case 'emissao':
        setParametroFiltro({
          emissaoInicio: dataInicio,
          emissaoFim: dataFim,
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;

      case 'entrega':
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: dataInicio,
          entregaFim: dataFim,
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;
      case 'cliente':
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          cliente: tipoFiltro.cliente,
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;
      default:
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
    }
  };*/

/*const selecionaFiltro = (tipoFiltro) => {
    console.log('tipofiltro ', tipoFiltro);

    setTipoFiltro(tipoFiltro.tipoFiltro);

    switch (tipoFiltro.tipoFiltro) {
      case 'emissao':
        setParametroFiltro({
          emissaoInicio: dataInicio,
          emissaoFim: dataFim,
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;

      case 'entrega':
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: dataInicio,
          entregaFim: dataFim,
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;

      case 'cliente':
        // NÃO chamar setClienteSelecionado aqui
        // O Autocomplete já faz isso no onChange
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          cliente: tipoFiltro.cliente,
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;

      default:
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
    }
  };

  const atualizaMateriaPrima = (
    producao,
    qtde,
    materia,
    vincada,
    utilizaTodoEstoque
  ) => {
    setLoading(true);
    api
      .put(
        '/producao/define/materiaprima',
        {
          producao: producao,
          materia: materia,
          quantidade: qtde,
          vincada: vincada,
          usuario: usuarioIDLogado,
          utilizaTodoEstoque: utilizaTodoEstoque,
        },
        {
          headers: { banco: empresaAtiva },
        }
      )
      .then(() => {
        toast.success('Producão alterada com sucesso ');
        setAtualizaFiltro(!atualizaFiltro);
      })
      .catch((err) => {
        toast.success('Erro ao  alterar Producao ');
        console.log(err);
        setAtualizaFiltro(!atualizaFiltro);
      })
      .finally(() => setLoading(false));
  };

  const solicitaCompra = (producao, duplicada) => {
    if (duplicada !== 0) {
      confirm({
        title: 'Alerta!',
        description: `Existe uma ou mais ordens vinculadas a esse pedido, Verifique!  `,
        confirmationText: 'OK',
        cancellationText: 'CANCELAR',
      })
        .then(() => {
          confirm({
            title: 'Confirme a Operação',
            description: 'Deseja solicitar a compra? ',
            confirmationText: 'SIM',
            cancellationText: 'NÃO',
          })
            .then(() => {
              setLoading(true);
              api
                .put(
                  '/producao/solicitar/compra',
                  {
                    producao: producao,
                    usuario: usuarioIDLogado,
                  },
                  {
                    headers: { banco: empresaAtiva },
                  }
                )
                .then(() => {
                  toast.success('Producão alterada com sucesso ');
                  setAtualizaFiltro(!atualizaFiltro);
                })
                .catch((err) => {
                  toast.success('Erro ao  alterar Producao ');
                  console.log(err);
                  setAtualizaFiltro(!atualizaFiltro);
                })
                .finally(() => setLoading(false));
            })

            .catch(() => {
              /* ... */
/* });
        })
        .catch(() => {});
    } else {
      confirm({
        title: 'Confirme a Operação',
        description: 'Deseja solicitar a compra? ',
        confirmationText: 'SIM',
        cancellationText: 'NÃO',
      })
        .then(() => {
          setLoading(true);
          api
            .put(
              '/producao/solicitar/compra',
              {
                producao: producao,
                usuario: usuarioIDLogado,
              },
              {
                headers: { banco: empresaAtiva },
              }
            )
            .then(() => {
              toast.success('Producão alterada com sucesso ');
              setAtualizaFiltro(!atualizaFiltro);
            })
            .catch((err) => {
              toast.success('Erro ao  alterar Producao ');
              console.log(err);
              setAtualizaFiltro(!atualizaFiltro);
            })
            .finally(() => setLoading(false));
        })

        .catch(() => {
          /* ... */
/* });
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <Box>
        <TitlePage title="Reserva Materia Prima" />
        <Box>
          <Box marginLeft={'6%'}>
            <Typography variant="subtitle2">Período </Typography>
          </Box>

          <Stack
            direction={{ xs: 'row', sm: 'row', md: 'row', lg: 'row' }}
            spacing={{ xs: 1, sm: 1, md: 3 }}
            mt={2}
            mb={2}
          >
            <Box width={'4%'} display={'flex'} justifyContent={'center'}>
              <Button
                onClick={() => setAtualizaFiltro(!atualizaFiltro)}
                sx={{
                  borderRadius: '50%',
                  width: '25%',
                  height: '100%',
                  backgroundColor: 'primary.success',
                }}
              >
                <RefreshIcon sx={{ color: 'white' }} />
              </Button>
            </Box>
            <Box width={'13%'}>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Emissão Inicial "
                type="date"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
              />
            </Box>
            <Box width={'13%'}>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Emissão Final"
                type="date"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
              />
            </Box>

            <Box width={'20%'}>
              <Box>
                <Typography variant="subtitle2">Filtra por Data</Typography>
              </Box>
              <NativeSelect
                value={tipoFiltro}
                fullWidth
                onChange={(e) =>
                  selecionaFiltro({ tipoFiltro: e.target.value })
                }
              >
                <option default value={''}>
                  Todos os Registros
                </option>
                <option value={'emissao'}>Por Emissao</option>
                <option value={'entrega'}>Por Data Entrega </option>
              </NativeSelect>
            </Box>
            <Box width={'45%'}>
              {/*  <Box>
                <Typography variant="subtitle2">Filtrar por Cliente</Typography>
              </Box>
              <FormControl fullWidth>
                <NativeSelect
                  fullWidth
                  value={clienteSelecionado}
                  onChange={(e) =>
                    selecionaFiltro({
                      tipoFiltro: 'cliente',
                      cliente: e.target.value,
                    })
                  }
                >
                  <option value={''}>Todos os Registros </option>
                  {listaClientes.length > 0 ? (
                    listaClientes.map((cliente) => {
                      return (
                        <option key={cliente.codigo} value={cliente.codigo}>
                          {cliente.nome_fantasia
                            ? cliente.nome_fantasia
                            : cliente.razao_social}
                        </option>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </NativeSelect>
                  </FormControl>*/ /*}

              <Box>
                <Typography variant="subtitle2">Filtrar por Cliente</Typography>
              </Box>

              <FormControl fullWidth>
                <Autocomplete
                  value={clienteSelecionado}
                  onChange={(event, newValue) => {
                    console.log('onChange - newValue:', newValue);
                    setClienteSelecionado(newValue);

                    if (newValue) {
                      selecionaFiltro({
                        tipoFiltro: 'cliente',
                        cliente: newValue.codigo,
                      });
                    } else {
                      selecionaFiltro({
                        tipoFiltro: '',
                        cliente: '',
                      });
                    }
                  }}
                  options={listaClientes}
                  getOptionLabel={(option) => {
                    console.log('getOptionLabel - option:', option);
                    if (!option) return '';
                    if (typeof option === 'string') return option;
                    return option.nome_fantasia || option.razao_social || '';
                  }}
                  isOptionEqualToValue={(option, value) => {
                    console.log(
                      'isOptionEqualToValue - option:',
                      option,
                      'value:',
                      value
                    );
                    if (!value || !option) return false;
                    return option.codigo === value.codigo;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      size="small"
                      placeholder="Selecione um cliente"
                    />
                  )}
                />
              </FormControl>
            </Box>
          </Stack>
        </Box>
        <Divider />
        <TabelaResultados
          listaOrdens={listaOrdens}
          listaMateriasPrima={listaMateriasPrima}
          atualizaMateriaPrima={atualizaMateriaPrima}
          solicitaCompra={solicitaCompra}
        />
      </Box>
    </>
  );
};

export default ReservaMateriaPrima;
*/

import { useEffect, useState } from 'react';
import {
  NativeSelect,
  TextField,
  Box,
  FormControl,
  Stack,
  Divider,
  Typography,
  Button,
  Autocomplete,
} from '@mui/material';

import { toast } from 'react-toastify';
import moment from 'moment';

import api from '../../../../api/api';
import { useAuthState } from '../../../../contexts/AuthContext';
import Spinner from '../../../../components/Spinner/Spinner';
import TabelaResultados from './TabelaResultados/TabelaResultados';
import TitlePage from '../../../../components/TitlePage/TitlePage';
import { useConfirm } from 'material-ui-confirm';
import RefreshIcon from '@mui/icons-material/Refresh';

const ReservaMateriaPrima = () => {
  const { empresaAtiva, usuarioIDLogado } = useAuthState();
  const [loading, setLoading] = useState(false);
  const [listaOrdens, setListaOrdens] = useState([]);
  const [listaOrdensOriginal, setListaOrdensOriginal] = useState([]);
  const [listaClientes, setListaClientes] = useState([]);
  const [listaClientesFiltrados, setListaClientesFiltrados] = useState([]); // Clientes filtrados
  const [listaMateriasPrima, setListaMateriasPrimas] = useState([]);
  const [listaNotas, setListaNotas] = useState([]);
  const [dataInicio, setDataInicio] = useState(moment().format('YYYY-MM-DD'));
  const [dataFim, setDataFim] = useState(moment().format('YYYY-MM-DD'));
  const [tipoFiltro, setTipoFiltro] = useState('');
  const [mostrarSomenteVincadas, setMostrarSomenteVincadas] = useState('TODAS');
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [notaSelecionada, setNotaSelecionada] = useState(null);
  const [atualizaFiltro, setAtualizaFiltro] = useState(false);
  const confirm = useConfirm();
  const [parametroFiltro, setParametroFiltro] = useState({
    emissaoInicio: '',
    emissaoFim: '',
    entregaInicio: '',
    entregaFim: '',
    cliente: '',
    status: 'RESERVA',
    materia: '0',
    maquina: '',
  });

  useEffect(() => {
    setLoading(true);
    api
      .post('/producao/lista', parametroFiltro, {
        headers: { banco: empresaAtiva },
      })
      .then(({ data }) => {
        setListaOrdensOriginal(data);
        setListaOrdens(data);
        console.log(data);

        // Extrai todas as notas únicas das ordens
        const notasSet = new Set();
        data.forEach((ordem) => {
          if (
            ordem.materia_prima_comprada &&
            Array.isArray(ordem.materia_prima_comprada)
          ) {
            ordem.materia_prima_comprada.forEach((materia) => {
              if (materia.nota) {
                notasSet.add(materia);
              }
            });
          }
        });
        setListaNotas(Array.from(notasSet).sort());
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  }, [parametroFiltro, empresaAtiva, atualizaFiltro]);

  useEffect(() => {
    api
      .get('/cliente/lista1', {
        headers: {
          banco: empresaAtiva,
        },
      })
      .then(({ data }) => {
        setListaClientes(data);
      })
      .catch(({ data }) =>
        toast.error('Erro ao buscar dados do cliente', data),
      );
  }, [empresaAtiva, atualizaFiltro]);

  // Filtra clientes que estão presentes nas ordens
  useEffect(() => {
    if (listaClientes.length > 0 && listaOrdensOriginal.length > 0) {
      // Extrai códigos únicos de clientes das ordens
      const codigosClientes = new Set(
        listaOrdensOriginal.map((ordem) => ordem.opr_cd_cliente),
      );

      // Filtra apenas os clientes que estão nas ordens
      const clientesFiltrados = listaClientes.filter((cliente) =>
        codigosClientes.has(cliente.codigo),
      );

      setListaClientesFiltrados(clientesFiltrados);
    } else {
      setListaClientesFiltrados([]);
    }
  }, [listaClientes, listaOrdensOriginal]);

  useEffect(() => {
    api
      .post(
        '/materiaPrima/lista',
        { estoque: 'SIM' },
        {
          headers: {
            banco: empresaAtiva,
          },
        },
      )
      .then(({ data }) => {
        setListaMateriasPrimas(data);
      })
      .catch((err) => {
        console.log(err);
        toast.error('Erro ao buscar dados da MateriaPrima', err);
      });
  }, [empresaAtiva, atualizaFiltro]);

  // Filtro por nota

  useEffect(() => {
    if (notaSelecionada) {
      const ordensFiltradas = listaOrdensOriginal.filter((ordem) => {
        if (
          ordem.materia_prima_comprada &&
          Array.isArray(ordem.materia_prima_comprada)
        ) {
          return ordem.materia_prima_comprada.some(
            (materia) => materia.nota === notaSelecionada.nota,
          );
        }
        return false; /**/
      });
      setListaOrdens(ordensFiltradas);
    } else {
      setListaOrdens(listaOrdensOriginal);
    }
  }, [notaSelecionada, listaOrdensOriginal]);

  const filtroVincadas = (e) => {
    setLoading(true);
    setMostrarSomenteVincadas(e.target.value);

    if (e.target.value === 'SIM') {
      const ordensFiltradas = listaOrdensOriginal.filter(
        (ordem) => ordem.vincada === 'SIM',
      );

      setListaOrdens(ordensFiltradas);
    } else if (e.target.value === 'NÃO') {
      const ordensFiltradas = listaOrdensOriginal.filter(
        (ordem) => ordem.vincada === 'NÃO',
      );
      setListaOrdens(ordensFiltradas);
    } else {
      setListaOrdens(listaOrdensOriginal); // restaura a lista completa
    }
    setLoading(false);
  };
  const selecionaFiltro = (tipoFiltro) => {
    setTipoFiltro(tipoFiltro.tipoFiltro);

    switch (tipoFiltro.tipoFiltro) {
      case 'emissao':
        setParametroFiltro({
          emissaoInicio: dataInicio,
          emissaoFim: dataFim,
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;

      case 'entrega':
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: dataInicio,
          entregaFim: dataFim,
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;
      case 'cliente':
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          cliente: tipoFiltro.cliente,
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
        break;
      default:
        setParametroFiltro({
          emissaoInicio: '',
          emissaoFim: '',
          entregaInicio: '',
          entregaFim: '',
          cliente: '',
          status: 'RESERVA',
          materia: '0',
          maquina: '',
        });
    }
  };

  const atualizaMateriaPrima = (
    producao,
    qtde,
    materia,
    vincada,
    utilizaTodoEstoque,
  ) => {
    setLoading(true);
    api
      .put(
        '/producao/define/materiaprima',
        {
          producao: producao,
          materia: materia,
          quantidade: qtde,
          vincada: vincada,
          usuario: usuarioIDLogado,
          utilizaTodoEstoque: utilizaTodoEstoque,
        },
        {
          headers: { banco: empresaAtiva },
        },
      )
      .then(() => {
        toast.success('Producão alterada com sucesso ');
        setAtualizaFiltro(!atualizaFiltro);
      })
      .catch((err) => {
        toast.success('Erro ao  alterar Producao ');
        console.log(err);
        setAtualizaFiltro(!atualizaFiltro);
      })
      .finally(() => setLoading(false));
  };

  const solicitaCompra = (producao, duplicada) => {
    if (duplicada !== 0) {
      confirm({
        title: 'Alerta!',
        description: `Existe uma ou mais ordens vinculadas a esse pedido, Verifique!  `,
        confirmationText: 'OK',
        cancellationText: 'CANCELAR',
      })
        .then(() => {
          confirm({
            title: 'Confirme a Operação',
            description: 'Deseja solicitar a compra? ',
            confirmationText: 'SIM',
            cancellationText: 'NÃO',
          })
            .then(() => {
              setLoading(true);
              api
                .put(
                  '/producao/solicitar/compra',
                  {
                    producao: producao,
                    usuario: usuarioIDLogado,
                  },
                  {
                    headers: { banco: empresaAtiva },
                  },
                )
                .then(() => {
                  toast.success('Producão alterada com sucesso ');
                  setAtualizaFiltro(!atualizaFiltro);
                })
                .catch((err) => {
                  toast.success('Erro ao  alterar Producao ');
                  console.log(err);
                  setAtualizaFiltro(!atualizaFiltro);
                })
                .finally(() => setLoading(false));
            })

            .catch(() => {
              /* ... */
            });
        })
        .catch(() => {});
    } else {
      confirm({
        title: 'Confirme a Operação',
        description: 'Deseja solicitar a compra? ',
        confirmationText: 'SIM',
        cancellationText: 'NÃO',
      })
        .then(() => {
          setLoading(true);
          api
            .put(
              '/producao/solicitar/compra',
              {
                producao: producao,
                usuario: usuarioIDLogado,
              },
              {
                headers: { banco: empresaAtiva },
              },
            )
            .then(() => {
              toast.success('Producão alterada com sucesso ');
              setAtualizaFiltro(!atualizaFiltro);
            })
            .catch((err) => {
              toast.success('Erro ao  alterar Producao ');
              console.log(err);
              setAtualizaFiltro(!atualizaFiltro);
            })
            .finally(() => setLoading(false));
        })

        .catch(() => {
          /* ... */
        });
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <Box>
        <TitlePage title="Reserva Materia Prima" />
        <Box>
          <Box marginLeft={'6%'}>
            <Typography variant="subtitle2">Período </Typography>
          </Box>

          <Stack
            direction={{ xs: 'row', sm: 'row', md: 'row', lg: 'row' }}
            spacing={{ xs: 1, sm: 1, md: 3 }}
            mt={2}
            mb={2}
          >
            <Box width={'4%'} display={'flex'} justifyContent={'center'}>
              <Button
                onClick={() => setAtualizaFiltro(!atualizaFiltro)}
                sx={{
                  borderRadius: '50%',
                  width: '25%',
                  height: '100%',
                  backgroundColor: 'primary.success',
                }}
              >
                <RefreshIcon sx={{ color: 'white' }} />
              </Button>
            </Box>
            <Box width={'13%'}>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Emissão Inicial "
                type="date"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
              />
            </Box>
            <Box width={'13%'}>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Emissão Final"
                type="date"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
              />
            </Box>

            <Box width={'15%'}>
              <Box>
                <Typography variant="subtitle2">Filtra por Data</Typography>
              </Box>
              <NativeSelect
                value={tipoFiltro}
                fullWidth
                onChange={(e) =>
                  selecionaFiltro({ tipoFiltro: e.target.value })
                }
              >
                <option default value={''}>
                  Todos os Registros
                </option>
                <option value={'emissao'}>Por Emissao</option>
                <option value={'entrega'}>Por Data Entrega </option>
              </NativeSelect>
            </Box>
            <Box width={'20%'}>
              <Box>
                <Typography variant="subtitle2">Filtrar por Cliente</Typography>
              </Box>

              <FormControl fullWidth>
                <Autocomplete
                  value={
                    listaClientesFiltrados.find(
                      (c) => c.codigo === clienteSelecionado,
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setClienteSelecionado(newValue.codigo);
                      selecionaFiltro({
                        tipoFiltro: 'cliente',
                        cliente: newValue.codigo,
                      });
                    } else {
                      setClienteSelecionado(null);
                      selecionaFiltro({
                        tipoFiltro: '',
                        cliente: '',
                      });
                    }
                  }}
                  options={listaClientesFiltrados}
                  getOptionLabel={(option) => {
                    if (!option) return '';
                    if (typeof option === 'string') return option;
                    return option.nome_fantasia || option.razao_social || '';
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !option) return false;
                    return option.codigo === value.codigo;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" size="small" />
                  )}
                />
              </FormControl>
            </Box>

            {/* FILTRO POR NOTA */}
            <Box width={'15%'}>
              <Box>
                <Typography variant="subtitle2">Filtrar por Nota</Typography>
              </Box>
              <FormControl fullWidth>
                <Autocomplete
                  value={notaSelecionada}
                  onChange={(event, newValue) => {
                    setNotaSelecionada(newValue);
                  }}
                  options={listaNotas}
                  getOptionLabel={(option) =>
                    `${option.nota} / ${option.fornecedor}` || ''
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      size="small"
                      placeholder="Selecione uma nota"
                    />
                  )}
                />
              </FormControl>
            </Box>
            <Box width={'15%'}>
              <Box>
                <Typography variant="subtitle2">
                  Mostrar Somente vincadas
                </Typography>
              </Box>
              <FormControl fullWidth>
                <NativeSelect
                  onChange={(e) => filtroVincadas(e)}
                  value={mostrarSomenteVincadas}
                >
                  <option value="">TODAS</option>
                  <option value="SIM">VINCADAS</option>
                  <option value="NÃO">SEM VINCO</option>
                </NativeSelect>
              </FormControl>
            </Box>
          </Stack>
        </Box>
        <Divider />
        <TabelaResultados
          listaOrdens={listaOrdens}
          listaMateriasPrima={listaMateriasPrima}
          atualizaMateriaPrima={atualizaMateriaPrima}
          solicitaCompra={solicitaCompra}
        />
      </Box>
    </>
  );
};

export default ReservaMateriaPrima;
